<template>
  <div class="agent-entry">
    <a
      class="agent-entry__button"
      :href="href"
      :target="target"
      :rel="rel"
    >
      <div class="agent-entry__icon-wrap" aria-hidden="true">
        <svg
          class="agent-entry__icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2.75L13.8449 8.15514L19.25 10L13.8449 11.8449L12 17.25L10.1551 11.8449L4.75 10L10.1551 8.15514L12 2.75Z"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19 3.5V6.5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <path
            d="M20.5 5H17.5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <path
            d="M5 16.5V18.5"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <path
            d="M6 17.5H4"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
        </svg>
        <span class="agent-entry__status">
          <span class="agent-entry__status-ping"></span>
          <span class="agent-entry__status-dot"></span>
        </span>
      </div>
      <div class="agent-entry__content">
        <span class="agent-entry__title">{{ title }}</span>
        <span v-if="showBadge && badgeText" class="agent-entry__badge">
          {{ badgeText }}
        </span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "AgentEntry",
  props: {
    href: {
      type: String,
      default: "javascript:void(0);",
    },
    target: {
      type: String,
      default: "_blank",
    },
    rel: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "AI 工作台",
    },
    badgeText: {
      type: String,
      default: "NEW",
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-entry {
  box-sizing: border-box;
  // width: 100%;
  width: 200px;
  padding: 12px 12px 8px;
  border-top: 1px solid #f1f5f9;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(12px);
  &.is-closed {
    .agent-entry__button {
      background: none;
      border: none;
      width: 40px;
      box-shadow: none;
    }
    .agent-entry__content {
      display: none;
    }
  }

  &__button {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid rgba(199, 210, 254, 0.5);
    border-radius: 12px;
    background: linear-gradient(90deg, #eff6ff 0%, #eef2ff 100%);
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
    color: #4f46e5;
    cursor: pointer;
    transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
    appearance: none;
    outline: none;
    text-decoration: none;
  }

  &__button:hover,
  &__button:focus-visible {
    background: linear-gradient(90deg, #dbeafe 0%, #e0e7ff 100%);
    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.12);
    transform: translateY(-1px);
  }

  &__icon-wrap {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
  }

  &__icon {
    width: 16px;
    height: 16px;
    color: #6366f1;
    animation: agent-entry-pulse 2s ease-in-out infinite;
  }

  &__status {
    position: absolute;
    top: -4px;
    right: -5px;
    width: 8px;
    height: 8px;
  }

  &__status-ping,
  &__status-dot {
    position: absolute;
    inset: 0;
    border-radius: 999px;
  }

  &__status-ping {
    background: rgba(129, 140, 248, 0.75);
    animation: agent-entry-ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  &__status-dot {
    background: #6366f1;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    min-width: 0;
    font-size: 12px;
  }

  &__title {
    font-size: 14px;
    overflow: hidden;
    color: #4c1d95;
    font-family: SourceHanSansCN-Medium, sans-serif;
    font-weight: 400;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__badge {
    flex-shrink: 0;
    margin-left: 12px;
    padding: 2px 6px;
    border-radius: 999px;
    background: #4f46e5;
    color: #fff;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN-Medium, sans-serif;
    font-size: 8px;
    font-style: italic;
    font-weight: 700;
    letter-spacing: 0.4px;
    line-height: 1.2;
  }
}

@keyframes agent-entry-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.65;
    transform: scale(1.08);
  }
}

@keyframes agent-entry-ping {
  75%,
  100% {
    opacity: 0;
    transform: scale(2);
  }
}
</style>
